var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24424_1305)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 32,
    height: 32,
    rx: 5,
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2308 20.2308C25.2308 21.0675 24.9826 21.8855 24.5178 22.5813C24.0529 23.277 23.3921 23.8193 22.619 24.1395C21.846 24.4597 20.9953 24.5435 20.1746 24.3802C19.3539 24.217 18.6001 23.8141 18.0084 23.2224C17.4167 22.6307 17.0138 21.8768 16.8505 21.0561C16.6873 20.2355 16.7711 19.3848 17.0913 18.6117C17.4115 17.8387 17.9538 17.1779 18.6495 16.713C19.3453 16.2481 20.1632 16 21 16C22.1217 16.0013 23.1971 16.4474 23.9902 17.2406C24.7833 18.0337 25.2295 19.1091 25.2308 20.2308ZM31 21C31 22.9778 30.4135 24.9112 29.3147 26.5557C28.2159 28.2002 26.6541 29.4819 24.8268 30.2388C22.9996 30.9957 20.9889 31.1937 19.0491 30.8078C17.1093 30.422 15.3275 29.4696 13.9289 28.0711C12.5304 26.6725 11.578 24.8907 11.1922 22.9509C10.8063 21.0111 11.0043 19.0004 11.7612 17.1732C12.5181 15.3459 13.7998 13.7841 15.4443 12.6853C17.0888 11.5865 19.0222 11 21 11C23.6513 11.0028 26.1932 12.0573 28.068 13.932C29.9427 15.8068 30.9972 18.3487 31 21ZM29.4615 21C29.4603 19.8611 29.2294 18.7341 28.7826 17.6865C28.3359 16.6389 27.6824 15.6921 26.8614 14.9028C26.0403 14.1135 25.0685 13.4979 24.0041 13.0928C22.9396 12.6878 21.8044 12.5015 20.6663 12.5452C16.1375 12.7202 12.526 16.4923 12.5385 21.024C12.5428 23.087 13.3037 25.0768 14.6769 26.6163C15.2362 25.8052 15.9466 25.1095 16.7692 24.5673C16.8394 24.521 16.9228 24.4989 17.0066 24.5045C17.0905 24.51 17.1702 24.5429 17.2337 24.5981C18.279 25.5023 19.615 25.9999 20.9971 25.9999C22.3793 25.9999 23.7152 25.5023 24.7606 24.5981C24.824 24.5429 24.9037 24.51 24.9876 24.5045C25.0715 24.4989 25.1549 24.521 25.225 24.5673C26.0487 25.1092 26.7601 25.8049 27.3202 26.6163C28.7002 25.0712 29.4626 23.0717 29.4615 21Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24424_1305",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_24424_1305"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24424_1305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24424_1305",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCseActive);
export default __webpack_public_path__ + "static/media/cseActive.510a16a9e9642826e89677fb28f80e95.svg";
export { ForwardRef as ReactComponent };